import { registerPlugin } from "@capacitor/core";
import type { NativeKeepAwakePlugin } from "@yjsgames/screen-wake-lock";

export const ScreenWakeLockNative =
  registerPlugin<NativeKeepAwakePlugin>("ScreenWakeLock");
